import React, { /*Suspense, */lazy } from 'react';
import { BrowserRouter, Router, Route, Switch, Redirect } from "react-router-dom";

import history from './history';

import PushHistory from './utils/PushHistory';
import { getSystemSettings } from './utils/SettingsRetriever';
import CheckProtected from './utils/Auth';
import PathTranslator from './utils/PathTranslator';

// import LoadingScreen from './components/Layout/LoadingScreen';
import BookingLayout from './components/Layout';
import B2BLayout from './B2B/components/Layout';

// customer pages
const AsyncLanding = lazy(() => import("./containers/Landing"));
const AsyncHome = lazy(() => import('./containers/Home'));
const AsyncKoediaLodging = lazy(() => import('./containers/LodgingKoedia'));
const AsyncActivities = lazy(() => import('./containers/Activities'));
const AsyncMerchandise = lazy(() => import('./containers/Merchandise'));
const AsyncPackages = lazy(() => import('./containers/Packages'));
const AsyncPackage = lazy(() => import('./containers/Package'));
const AsyncCart = lazy(() => import('./containers/Cart'));
const AsyncLoginRegisterRegister = lazy(() => import('./containers/CheckoutProcess/LoginRegister'));
const AsyncLogin = lazy(() => import('./containers/Login'));
const AsyncPayment = lazy(() => import('./containers/CheckoutProcess/Payment'));
const AsyncReview = lazy(() => import('./containers/CheckoutProcess/Review'));
const AsyncCheckoutProcessing = lazy(() => import('./containers/CheckoutProcess/ConfirmProcess'));
const AsyncCPCustomerRequirements = lazy(() => import('./containers/CheckoutProcess/CustomerRequirements'));
const AsyncPayment2 = lazy(() => import('./containers/CheckoutProcess2/Payment'));
const AsyncReview2 = lazy(() => import('./containers/CheckoutProcess2/Review'));
const AsyncCPCustomerRequirements2 = lazy(() => import('./containers/CheckoutProcess2/CustomerRequirements'));
const AsyncLoginRegisterRegister2 = lazy(() => import('./containers/CheckoutProcess2/LoginRegister'));
const AsyncResetPassword = lazy(() => import('./containers/ResetPassword'));
const AsyncLogout = lazy(() => import('./containers/Logout'));
const AsyncSuppliers = lazy(() => import('./containers/Suppliers'));
// const AsyncSuppliers = lazy(() => import('./containers/NewSuppliersGrid'));
const AsyncSupplier = lazy(() => import('./containers/Supplier'));
const AsyncLiftTickets = lazy(() => import('./containers/LiftTickets'));
const AsyncTicketsView = lazy(() => import('./containers/LiftTickets/TicketsView'));
const AsyncCarRental = lazy(() => import('./containers/CarRentals/'));
const AsyncFlight = lazy(() => import('./containers/Flights/'));
const AsyncPromocode = lazy(() => import('./containers/Promocode/'));
const AsyncPromocodeV2 = lazy(() => import('./containers/PromocodeV2/'));
const AsyncCheckoutComplete = lazy(() => import('./containers/Checkout/complete'));
const AsyncCheckoutCompleteV2 = lazy(() => import('./containers/Checkout/complete.v2'));
const AsyncCheckoutError = lazy(() => import('./containers/Checkout/error'));
const AsyncProfile = lazy(() => import('./containers/Profile'));
const AsyncAccount = lazy(() => import('./containers/Account'));
const AsyncMyRewards = lazy(() => import('./containers/MyRewards'));
const AsyncInapp = lazy(() => import('./containers/Inapp'));
const AsyncLandingEliberty = lazy(() => import('./containers/Eliberty/Landing'));
const AsyncTicketEliberty = lazy(() => import('./containers/Eliberty/Ticket'));
const AsyncElibertyCart = lazy(() => import('./containers/SpotlioCart'));
const AsyncLandingPage = lazy(() => import('./containers/LandingProducts'))

// new iteration
// const AsyncLandingPage = lazy(() => import('./containers/LandingPage'));
const AsyncNewLodging = lazy(() => import ('./containers/NewLodging'));
const AsyncNewSupplier = lazy(() => import ('./containers/NewSupplierPage'));

// b2b pages
const B2BHome = lazy(() => import('./B2B/containers/Home'));
const B2BAdminSignup = lazy(() => import('./B2B/containers/Home/AdminSignUp'));
const B2BDashboard = lazy(() => import('./B2B/containers/Dashboard'));
const B2BDashboardGuests = lazy(() => import('./B2B/containers/Dashboard/Guests'));
const B2BDashboardItineraries = lazy(() => import('./B2B/containers/Dashboard/Itineraries'));
const B2BDashboardPromocodes = lazy(() => import('./B2B/containers/Dashboard/Promocodes'));
const B2BUploader = lazy(() => import('./B2B/containers/Dashboard/Uploader'));
// b2b admin pages
const B2BAdminHome = lazy(() => import('./B2B/containers/AdminPanel/TravelAgents'));
const B2BAdminAgent = lazy(() => import('./B2B/containers/AdminPanel/PromoCodes'));
const B2BAdminPromocode = lazy(() => import('./B2B/containers/AdminPanel/NewPromoCodes'));

const AsyncNotFound = lazy(() => import('./containers/NotFound'));

// static pages

const AsyncStaticPage = lazy(() => import("./containers/StaticPage"));

const extractConfig = (path, system, wholeConfig = false, subSection) => {
  let routes = [];
  // if (system.hasOwnProperty('categories')) {
  if (system.categories) {
    system.categories.forEach(category => {
      if (subSection){
        if (category.code === subSection) {
          if (wholeConfig) routes = { id: system.id, ...category };
          else routes = category.href;
        }
      } else {
        if (category.code === path) {
          if (wholeConfig) routes = { id: system.id, ...category };
          else routes = category.href;
        }
      }
    });
  }
  return routes;
}

const PrivateRoute = ({ render: Component, ...rest }) => {
  return <Route
    {...rest}
    render={(props) => (
      CheckProtected.getAuth() === true
      ? <Component {...props} />
      : PushHistory('/b2b')
    )}
  />
};

const RenderBookingLayout = (children, props) => {
  return (
    <BookingLayout customer={props.customerState} system={props.system} config={props.config}>
      {children}
    </BookingLayout>
  )
}

const RenderB2BLayout = (children) => {
  return (
    <B2BLayout>
      {children}
    </B2BLayout>
  )
}


export default (props) => {
  const _PathTranslator = (path) => PathTranslator(path, props.system);

  let activitiesRoutes = [];
  let lodgingRoutes = [];
  let staticPagesRoutes = [];

  props.system.categories.forEach((val, idx) => {
    if (val.type === 'activities') {
      activitiesRoutes.push(
        <PrivateRoute key={idx} exact path={_PathTranslator([extractConfig(val.code, props.system)])} render={(routeProps) => {
          return RenderBookingLayout(<AsyncActivities {...routeProps} section={val.code} configuration={extractConfig(val.code, props.system, true)} />, props);
        }} />,
      );
    }
    if (val.type === 'merchandise') {
      activitiesRoutes.push(
        <PrivateRoute key={idx} exact path={_PathTranslator([extractConfig(val.code, props.system)])} render={(routeProps) => {
          return RenderBookingLayout(<AsyncMerchandise {...routeProps} section={val.code} configuration={extractConfig(val.code, props.system, true)} />, props);
        }} />,
      );
    }

    if (val.type === 'lodging') {
      lodgingRoutes.push(
        <PrivateRoute key={idx} exact path={_PathTranslator([extractConfig(val.code, props.system)])} render={(routeProps) => {
          let lodgingConfig = extractConfig('lodging', props.system, true, val.code);
          if ( lodgingConfig.template && lodgingConfig.template === "lodging2" ) {
            return RenderBookingLayout(
              <AsyncNewLodging {...routeProps} section="lodging" configuration={lodgingConfig} />, props
            );
          } else if (lodgingConfig.config && lodgingConfig.config.module === "koedia"){
            return RenderBookingLayout(
              <AsyncKoediaLodging {...routeProps} section="lodging" configuration={lodgingConfig} />, props
            );
          } else {
            return RenderBookingLayout(
              <AsyncHome {...routeProps} section="lodging" configuration={lodgingConfig} />, props
            );
          }
        }} />,
      );
    }

    if (val.type === 'promocode') {
      activitiesRoutes.push(
        <PrivateRoute key={idx} exact path={_PathTranslator([extractConfig(val.code, props.system)])} render={(routeProps) => {
          return (
            val.template ? 
            <AsyncPromocodeV2 {...routeProps} system={props.system} section={val.code} configuration={extractConfig(val.code, props.system, true)} />
            :
            RenderBookingLayout(
            <AsyncPromocode {...routeProps} section={val.code} configuration={extractConfig(val.code, props.system, true)} />
              , props)
          )
        }} />,
      );
    }

    if (val.type === 'packages') {
      activitiesRoutes.push(
        <PrivateRoute key={idx} exact path={_PathTranslator([extractConfig(val.code, props.system)])} render={(routeProps) => {
          return (
            RenderBookingLayout(
            <AsyncPackages {...routeProps} section={val.code} configuration={extractConfig(val.code, props.system, true)} />
              , props)
          )
        }} />,
      );
    }

    if (val.type === 'inapp') {
      activitiesRoutes.push(
        <PrivateRoute key={idx} exact path={_PathTranslator([extractConfig(val.code, props.system)])} render={(routeProps) => {
          return RenderBookingLayout(<AsyncInapp {...routeProps} section={val.code} configuration={extractConfig(val.code, props.system, true)} />, props);
        }} />,
      );
    }
    if (val.type === 'lift-tickets') {
      activitiesRoutes.push(
        <PrivateRoute key={idx} exact path={_PathTranslator([extractConfig(val.code, props.system)])} render={(routeProps) => {
          return RenderBookingLayout(<AsyncLiftTickets {...routeProps} section={val.code} configuration={extractConfig(val.code, props.system, true)} />, props)
        }} />,
        )
      activitiesRoutes.push(
        <PrivateRoute key={idx.toString() + 'ticketsview'} exact path={_PathTranslator(['/products/lift-tickets/results'])} render={(routeProps) => {
          return RenderBookingLayout(<AsyncTicketsView {...routeProps} section={val.code} configuration={extractConfig(val.code, props.system, true)} />, props);
        }} />,
      )
    }

    if (val.type === "static-page"){
      staticPagesRoutes.push(
        <PrivateRoute key={idx} exact path={_PathTranslator([extractConfig(val.code, props.system)])} render={(routeProps) => {
          return RenderBookingLayout(<AsyncStaticPage {...routeProps} section={val.code} configuration={extractConfig(val.code, props.system, true)} />, props);
        }} />,
      )
    }

    if (val.type === 'lift-tickets-eliberty') {
      activitiesRoutes.push(
        <PrivateRoute key={idx} exact path={_PathTranslator([extractConfig(val.code, props.system)])} render={(routeProps) => {
          return RenderBookingLayout(<AsyncLandingEliberty {...routeProps} section={val.code} configuration={extractConfig(val.code, props.system, true)} />, props)
        }} />,
        )
      activitiesRoutes.push(
        <PrivateRoute key={idx.toString() + 'ticketsview'} exact path={_PathTranslator(['/products/lift-tickets/results/'])} render={(routeProps) => {
          return RenderBookingLayout(<AsyncTicketEliberty {...routeProps} section={val.code} configuration={extractConfig(val.code, props.system, true)} />, props);
        }} />,
      )
    }
  });

  const defaultBookingRoutes = [
    <PrivateRoute key="cart" exact path={_PathTranslator(["/shopping-cart/review"])} render={(routeProps) => {
      return RenderBookingLayout(props.system.spotlioCart ? <AsyncElibertyCart {...routeProps} section="cart" /> : <AsyncCart {...routeProps} section="cart" />, props);
    } } />,
    <PrivateRoute key="login" exact path={_PathTranslator(["/login"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncLogin {...routeProps} section="login" />, props);
    } } />,
    <PrivateRoute key="resetpassword" exact path={_PathTranslator(["/checkout/resetpassword"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncResetPassword {...routeProps} section="resetpassword" />, props);
    } } />,
    <PrivateRoute key="logout" exact path={_PathTranslator(["/logout"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncLogout {...routeProps} section="logout" />, props);
    } } />,
    <PrivateRoute 
      key="checkout-complete" 
      exact path={
        _PathTranslator(
          [
            props.system && props.system.app && props.system.app.checkout && props.system.app.checkout.completedBookingSlug === "partial" 
            ?
            "/checkout/confirmed"
            :
            "/checkout/confirmed/:transactionId"
          ]
        )
      } 
      render={(routeProps) => {
        return RenderBookingLayout(<AsyncCheckoutComplete {...routeProps} section="checkout" />, props);
      } } 
    />,
    <PrivateRoute key="checkout-processing" exact path={_PathTranslator(["/checkout/processing"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncCheckoutProcessing {...routeProps} section="checkout" />, props);
    } } />,
    <PrivateRoute key="checkout-complete" exact path={_PathTranslator(["/checkout/completed/v2"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncCheckoutCompleteV2 {...routeProps} section="checkout" />, props);
    } } />,
    <PrivateRoute key="checkout-error" exact path={_PathTranslator(["/checkout/error"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncCheckoutError {...routeProps} section="checkout" />, props);
    } } />,
    <PrivateRoute key="profile" exact path={_PathTranslator(["/profile"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncProfile {...routeProps} section="profile" />, props);
    }} />,
    <PrivateRoute key="account" exact path={_PathTranslator(["/account"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncAccount {...routeProps} section="account" />, props);
    }} />,
    <PrivateRoute key="myrewards" exact path={_PathTranslator(["/myrewards"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncMyRewards {...routeProps} section="myrewards" />, props);
    }} />,
    // <PrivateRoute key="landing-page" exact path={_PathTranslator(["/landing"])} render={(routeProps) => {
    //   return RenderBookingLayout(<AsyncLandingPage {...routeProps} section="landing" />, props);
    // }} />
    <PrivateRoute key="landing-page" exact path={_PathTranslator(["/landing"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncLandingPage {...routeProps} section="landing" />, props);
    }} />
  ];

  const b2bRoutes = props.system.b2b ? [
    <Route key={'b2bLogin'} exact path={_PathTranslator(["/b2b"])} render={(routerProps) => {
      return RenderB2BLayout(<B2BHome {...routerProps} />)
    }} />,
    <PrivateRoute key={'b2bHome'} exact path={_PathTranslator(["/b2b/dashboard", "/b2b/home"])} render={(routerProps) => {
      return RenderB2BLayout(<B2BDashboard {...routerProps} />)
    }} />,
    <PrivateRoute key={'b2bGuests'} exact path={_PathTranslator(["/b2b/dashboard/guests", "/b2b/home/guests"])} render={(routerProps) => {
      return RenderB2BLayout(<B2BDashboardGuests {...routerProps} />)
    }} />,
    <PrivateRoute key={'b2bItineraries'} exact path={_PathTranslator(["/b2b/dashboard/itineraries", "/b2b/home/itineraries"])} render={(routerProps) => {
      return RenderB2BLayout(<B2BDashboardItineraries {...routerProps} />)
    }} />,
    <PrivateRoute key={'b2bPromocodes'} exact path={_PathTranslator(["/b2b/dashboard/promocodes", "/b2b/home/promocodes"])} render={(routerProps) => {
      return RenderB2BLayout(<B2BDashboardPromocodes {...routerProps} />)
    }} />,
    <Route key={'b2bUploader'} exact path={_PathTranslator(["/b2b/dashboard/import"])} render={(routerProps) => {
      return RenderB2BLayout(<B2BUploader {...routerProps} />)
    }} />,
    <Route key={'b2bAdmin'} exact path={_PathTranslator(["/b2b/admin"])} render={(routerProps) => {
      return RenderB2BLayout(<B2BAdminSignup {...routerProps} />)
    }} />,
    <Route key={'b2bAdminAgents'} exact path={_PathTranslator(["/b2b/admin/agents"])} render={(routerProps) => {
      return RenderB2BLayout(<B2BAdminHome {...routerProps} />)
    }} />,
    <Route key={'b2bAdminAgentChannel'} exact path={_PathTranslator(["/b2b/admin/agents/:agentId/:channelId"])} render={(routerProps) => {
      return RenderB2BLayout(<B2BAdminAgent {...routerProps} />)
    }} />,
    <Route key={'b2bAdminPromocodes'} exact path={_PathTranslator(["/b2b/admin/promocodes"])} render={(routerProps) => {
      return RenderB2BLayout(<B2BAdminPromocode {...routerProps} />)
    }} />
  ] : [];

  const checkoutRoutes = getSystemSettings() && getSystemSettings().checkout && getSystemSettings().checkout.template === "one" ? 
  [
    <PrivateRoute key="register" exact path={_PathTranslator(["/checkout/register"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncLoginRegisterRegister2 {...routeProps} section="register" />, props);
    } } />,
    <PrivateRoute key="payment" exact path={_PathTranslator(["/checkout/payment"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncPayment2 {...routeProps} section="payment" />, props);
    } } />,
    <PrivateRoute key="review" exact path={_PathTranslator(["/checkout/review"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncReview2 {...routeProps} section="review" />, props);
    } } />,
    <PrivateRoute key="checkoutCustomerRequirements" exact path={_PathTranslator(["/checkout/customer-requirements"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncCPCustomerRequirements2 {...routeProps} section="checkoutCustomerRequirements" />, props);
    } } />
  ]
  :
  [
    <PrivateRoute key="register" exact path={_PathTranslator(["/checkout/register"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncLoginRegisterRegister {...routeProps} section="register" />, props);
    } } />,
    <PrivateRoute key="payment" exact path={_PathTranslator(["/checkout/payment"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncPayment {...routeProps} section="payment" />, props);
    } } />,
    <PrivateRoute key="review" exact path={_PathTranslator(["/checkout/review"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncReview {...routeProps} section="review" />, props);
    } } />,
    <PrivateRoute key="checkoutCustomerRequirements" exact path={_PathTranslator(["/checkout/customer-requirements"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncCPCustomerRequirements {...routeProps} section="checkoutCustomerRequirements" />, props);
    } } />
  ]

  const sectionRoutes = [
    <PrivateRoute key="landing" exact path={_PathTranslator(["/select_destination"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncLanding {...routeProps} />, props);
    }} />,
    <PrivateRoute key="packages" exact path={_PathTranslator(["/packages", ...extractConfig('packages', props.system)])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncPackages {...routeProps} section="packages" configuration={extractConfig('packages', props.system, true)} />, props);
    }} />,
    <PrivateRoute key="package" exact path={_PathTranslator(["/packages/:slug/:packageId", ...extractConfig('package', props.system)])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncPackage {...routeProps} section="packages" configuration={extractConfig('packages', props.system, true)} />, props);
    }} />,
    <PrivateRoute key="suppliers" exact path={_PathTranslator(["/suppliers"])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncSuppliers {...routeProps} configuration={extractConfig('lodging', props.system, true)} section="suppliers" />, props);
    }} />,
    <PrivateRoute key="supplier" exact path={_PathTranslator(["/supplier/:slug/:supplierId", "/v2/supplier/:slug/:supplierId"])} render={(routeProps) => {
      if (getSystemSettings().supplierPage && getSystemSettings().supplierPage.template === "supplierPage2"){
        return RenderBookingLayout(<AsyncNewSupplier {...routeProps} section="supplier" />, props);
      } else {
        return RenderBookingLayout(<AsyncSupplier configuration={extractConfig('lodging', props.system, true)} {...routeProps} section="supplier" />, props);
      }
    }} />,
    <PrivateRoute key="car-rental" exact path={_PathTranslator(["/products/car-rental", ...extractConfig('car-rental', props.system)])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncCarRental {...routeProps} section="car-rental" configuration={extractConfig('car-rental', props.system, true)} />, props);
    }} />,
    <PrivateRoute key="flights" exact path={_PathTranslator(["/flights", ...extractConfig('flights', props.system)])} render={(routeProps) => {
      return RenderBookingLayout(<AsyncFlight {...routeProps} section="flights" configuration={extractConfig('flights', props.system, true)} />, props);
    }} />,

    ...lodgingRoutes,
    ...activitiesRoutes,
    ...staticPagesRoutes,
    ...defaultBookingRoutes,
    ...checkoutRoutes
  ];

  return (
    <BrowserRouter>
      <Router history={history}>
        {/* <Suspense fallback={<LoadingScreen message="Loading..." fullScreen />}> */}
          <Switch>
            { b2bRoutes.map(idx => idx) }
            { sectionRoutes.map(idx => idx) }
            <Route exact path={_PathTranslator(["/"])} render={() => <Redirect to={props.system.urlPrefix + (props.system.app.defaultPage || "/products/lodging") + window.location.search} />} />
            <BookingLayout customer={props.customerState} system={props.system} config={props.config}>
              <Route component={AsyncNotFound} />
            </BookingLayout>
          </Switch>
        {/* </Suspense> */}
      </Router>
    </BrowserRouter>
  )
}

// hello world
